/**
 * Auth Debug Utility
 * 
 * Standardizovani debug logovi za autentifikaciju i login proces.
 * Koristi obojene logove sa jasnim oznakama da se razlikuju od eID logova.
 */

const DEBUG_ENABLED = false; // Disabled - auth logging turned off

// ANSI color codes za konzolu
const colors = {
  reset: '\x1b[0m',
  bright: '\x1b[1m',
  dim: '\x1b[2m',
  red: '\x1b[31m',
  green: '\x1b[32m',
  yellow: '\x1b[33m',
  blue: '\x1b[34m',
  magenta: '\x1b[35m',
  cyan: '\x1b[36m',
};

// CSS stilovi za browser konzolu
const browserStyles = {
  info: 'color: #2196F3; font-weight: bold;',
  success: 'color: #4CAF50; font-weight: bold;',
  warning: 'color: #FF9800; font-weight: bold;',
  error: 'color: #F44336; font-weight: bold;',
  step: 'color: #9C27B0; font-weight: bold;',
};

/**
 * Proverava da li je browser konzola
 */
const isBrowser = typeof window !== 'undefined';

/**
 * Auth Debug Logger
 */
export const authDebug = {
  /**
   * Loguje početak login procesa
   */
  loginStart: () => {
    if (!DEBUG_ENABLED) return;
  },

  /**
   * Loguje korak u login procesu
   */
  step: () => {
    if (!DEBUG_ENABLED) return;
  },

  /**
   * Loguje uspešan korak
   */
  success: () => {
    if (!DEBUG_ENABLED) return;
  },

  /**
   * Loguje informacije
   */
  info: () => {
    if (!DEBUG_ENABLED) return;
  },

  /**
   * Loguje upozorenje
   */
  warning: (message, data = {}) => {
    if (!DEBUG_ENABLED) return;
    const msg = `  ⚠ [AUTH LOGIN] ${message}`;
    if (isBrowser) {
      console.warn(`%c${msg}`, browserStyles.warning, data);
    } else {
      console.warn(`${colors.yellow}${msg}${colors.reset}`, data);
    }
  },

  /**
   * Loguje grešku
   */
  error: (message, error = {}) => {
    if (!DEBUG_ENABLED) return;
    const msg = `  ✗ [AUTH LOGIN] ${message}`;
    if (isBrowser) {
      console.error(`%c${msg}`, browserStyles.error, error);
    } else {
      console.error(`${colors.red}${msg}${colors.reset}`, error);
    }
  },

  /**
   * Loguje token informacije (sa maskiranjem)
   */
  token: () => {
    if (!DEBUG_ENABLED) return;
  },

  /**
   * Loguje HTTP zahtev
   */
  request: () => {
    if (!DEBUG_ENABLED) return;
  },

  /**
   * Loguje HTTP odgovor
   */
  response: () => {
    if (!DEBUG_ENABLED) return;
  },

  /**
   * Loguje završetak login procesa
   */
  loginComplete: () => {
    if (!DEBUG_ENABLED) return;
  },
};

export default authDebug;




